import { snakeCase, text, timestamp } from 'drizzle-orm/pg-core'
import { id, timestamps } from '../utils/columns.helpers'
import { benefitApplicationsTable } from './benefit-applications.table'
import { rafflesTable } from './raffles.table'

export const raffleWinnersTable = snakeCase.table('raffle_winners', {
    id: id('rfw'),
    raffleId: text()
        .notNull()
        .references(() => rafflesTable.id, {
            onDelete: 'cascade',
            onUpdate: 'cascade',
        }),
    benefitApplicationId: text()
        .notNull()
        .unique()
        .references(() => benefitApplicationsTable.id, {
            onDelete: 'cascade',
            onUpdate: 'cascade',
        }),
    selectedAt: timestamp({ withTimezone: true }).defaultNow(),
    notes: text(),
    ...timestamps,
})
